var map = {
	"./site-logo-desktop-footer.svg": 27952,
	"./site-logo-desktop.svg": 89588,
	"./site-logo-drawer-mobile.svg": 44522,
	"./site-logo-drawer.svg": 26059,
	"./site-logo-mobile-drawer.svg": 8908,
	"./site-logo-mobile.svg": 68346,
	"./site-logo-sm.svg": 55080,
	"./site-logo-tv.svg": 94382,
	"./site-logo-wrapper-mobile-scrolled.svg": 63061,
	"./site-logo-wrapper-mobile.svg": 38464,
	"./site-logo-wrapper-scrolled.svg": 53578,
	"./site-logo-wrapper.svg": 43269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93680;